import {
  addressClassName,
  rowClassName,
  subtitleClassName,
  titleClassName,
} from './styles';

interface Props {
  name?: string;
  street?: string;
  city?: string;
  zip?: string;
  state?: string;
  country?: string;
}

const Address = ({ name, street, city, zip, state, country }: Props) => {
  return (
    <div className={addressClassName}>
      <span className={titleClassName}>{name}</span>
      <span className={subtitleClassName}>{street}</span>
      <div className={rowClassName}>
        {city && <span className={subtitleClassName}>{city}</span>}
        <span className={subtitleClassName}>{zip}</span>
      </div>
      <div className={rowClassName}>
        {state && <span className={subtitleClassName}>{state},</span>}
        <span className={subtitleClassName}>{country}</span>
      </div>
    </div>
  );
};

Address.displayName = 'Address';

export default Address;
